import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentCaseCalls, selectCurrentCaseEmails } from '../../../redux/currentCase/selectors';
import { ExternalUpdatesTable } from './ExternalUpdatesTable';
import { Divider } from '@material-ui/core';
import { PanelDialogue } from '../../common/PanelDialogue';
import { useTranslation } from 'react-i18next';

export default function CallTable (props) {
    const { t } = useTranslation();
    const {showCallTable, contractCalls, contractEmails, handleShowForms} = props;
    const anchorEl = document.getElementById("callTableIcon");
    const currentCaseCalls = useSelector(selectCurrentCaseCalls);
    const currentCaseEmails = useSelector(selectCurrentCaseEmails);

    const dataCallTable = contractCalls?.length >= currentCaseCalls?.length ? contractCalls : currentCaseCalls;
    const dataEmailTable = contractEmails?.length >= currentCaseEmails?.length ? contractEmails : currentCaseEmails;

    return (
        <PanelDialogue placement={"bottom"} anchorEl={anchorEl} open={showCallTable} showActionButtons={false} cancelFunction={() => handleShowForms("callTable")} title={t("CaseContent.RelatedData.Title")}>
            <ExternalUpdatesTable data={dataCallTable} dataKey={"callId"} title={t("CaseContent.RelatedData.CallsRelatedToCase")} noElementsMessage={t("CaseContent.RelatedData.NoCallsRelatedToCase")} handleShowForms={handleShowForms}/>
            <div style={{marginTop: "0.625rem", marginBottom: "0.5rem"}}><Divider/></div>
            <ExternalUpdatesTable data={dataEmailTable} dataKey={"uuiD"} title={t("CaseContent.RelatedData.MailsRelatedToCase")} noElementsMessage={t("CaseContent.RelatedData.NoMailsRelatedToCase")} handleShowForms={handleShowForms}/>
        </PanelDialogue>
    );
 }